import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Console } from 'console';
import { debounceTime } from 'rxjs/operators';
import { DialogBase, RentalInfo } from 't4core';
import { CampaignInfo, DiscountReasonInfo, GenerateVoucherResult } from '../../../../../projects/t4core/src/public-api';
import { RentalDialog } from '../../../../t4common/';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'createCampaignDialog',
  templateUrl: 'campaignInfoDialog.html',
})
export class CampaignInfoDialog extends DialogBase {

  public campaignId: string
  public isDialog: boolean

  constructor(
    public dialogRef: MatDialogRef<CampaignInfoDialog>,
    private route: ActivatedRoute,
    private router: Router,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
   
    super("CampaignInfoDialog");
    this.campaignId = data;

    this.isDialog = true;
  }
}
